import { Libraries } from '@react-google-maps/api';

export const Library: Libraries = ["places"];
